import React, { Component } from 'react'
import PropTypes from 'prop-types';
import styled from 'styled-components';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';
import { withRouter } from 'react-router-dom';

// CUSTOM COMPONENTS
import StaffCardContainer from 'containers/CompanyContainer/StaffCardContainer';

// CONSTANTS
import { constants } from 'constants/index';

// STYLED COMPONENTS
const GeneralCardWrapper = styled.div`
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
`
const ContainerWrapper = styled.div`
    padding: 3% 8% 4% 8%;
`
const TitleWrapper = styled.h3`
    font-size: 30px;
    font-weight: 400;
    letter-spacing: 0.5px;
    color: #7b7474;
`
const EmptyContainerWrapper = styled.div`
    display: flex;
    align-items: center;
    font: 20px Open Sans, Helvetica, sans-serif;
    font-weight: 200;
    letter-spacing: 0.5px;
    color: ${constants.color.grey34};
`;
class AdminContainer extends Component {

    handleClick = (type, data) => {
        this.props.selectItem(type,data)
    }

    render () {
        const { staff, title } = this.props;
        const isArrayEmpty = array => array.length > 0 ? false : true;
        return (
            <ContainerWrapper>
                <TitleWrapper > {title} </TitleWrapper>
                <GeneralCardWrapper>
                {staff && !isArrayEmpty(staff)
                    ? staff.map((employee, index) => {
                        if(employee){
                            return(
                                <StaffCardContainer
                                    key={`${employee.name ? employee.name.first : 'unknown'}${index}`}
                                    employee={employee}
                                    index={index}
                                    onClick={(type, data) => this.handleClick(type, data)}
                                    isAdmin={ true }
                                />
                            );
                        }
                        else {
                            return null;
                        }
                    })
                    : <EmptyContainerWrapper>
                        No {title} added yet
                    </EmptyContainerWrapper>
                }
                </GeneralCardWrapper>
            </ContainerWrapper>
        )
    }
};

export default withRouter(connect(null,actions)(AdminContainer));


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/AdminContainer.jsx